module.exports = __webpack_public_path__ + "img/icons.b66f26f7.svg";